import React, { ReactElement, ReactNode, useState } from 'react';
// import { useQuery } from 'react-apollo';
import { Button } from '@wds/button';
import { IconXCircle } from '@wds/icons';

import BannerBody from './BannerBody';
import { CallToActionType } from './CallToActionButtons';
import visibilityLogic from './helpers/visibilityLogic';
// import { getCollector } from './SEOBanner.graphql';
import useStyles from './useStyles';

export type SEOBannerPropsType = {
  callToActionButtons: CallToActionType[];
  children: ReactNode;
  collectorId: string;
  requestFromSearchEngine: boolean;
  closeButtonAriaText?: string;
  forceDoNotShowBanner?: boolean;
  langId?: string;
};

export default ({
  forceDoNotShowBanner = false,
  requestFromSearchEngine,
  children,
  callToActionButtons,
  collectorId,
  closeButtonAriaText = '',
}: SEOBannerPropsType): ReactElement | null => {
  const [forceDoNotShow, setForceDoNotShow] = useState(forceDoNotShowBanner || false);

  const { seoBanner, seoBannerContents, embeddedContainer, closeXButton } = useStyles();

  /// TODO: Remove the hard-coded collectionMethod and type value with the result from SurveyResponse/Respondent graph call
  const collectionMethod = 'NORMAL';
  const collectorType = 'WEBLINK';

  // const {
  //   loading: loadingCollector,
  //   error: errorCollector,
  //   data: collectorData,
  // } = useQuery(getCollector, {
  //   variables: {
  //     collectorId,
  //   },
  // });
  //
  // if (errorCollector) {
  //   throw errorCollector;
  // }
  //
  // if (!loadingCollector && !collectorData) {
  //   return null;
  // }

  if (!visibilityLogic(forceDoNotShow, requestFromSearchEngine, collectorType, collectionMethod)) {
    return null;
  }

  return (
    <div className={seoBanner}>
      <div className={seoBannerContents}>
        <div className={embeddedContainer}>
          <BannerBody callToActionButtons={callToActionButtons}>{children}</BannerBody>
        </div>
      </div>
      <div data-testid="SEOBanner__CloseButton" className={closeXButton}>
        <Button variant="text" color="secondary" label={closeButtonAriaText} onClick={() => setForceDoNotShow(true)}>
          <IconXCircle title="" />
        </Button>
      </div>
    </div>
  );
};
